import React from 'react';
import PropTypes from 'prop-types';
import {
  StripeForm,
  STRIPE_FORM_CONTEXT,
} from '@resy/ui-kitchen';

export default function PrepayStripe({
  $rootScope,
  AutomationMode,
  clientSecret,
  accountId,
  onSubmit,
  stripePublishableKey,
}) {
  return (
    <div className="PrepayPayment_Stripe">
      <div className="PrepayPayment_Stripe__form">
        <div className="Prepay__container">
          <StripeForm
            $rootScope={$rootScope}
            AutomationMode={AutomationMode}
            closeForm={onSubmit}
            matchMedia={$rootScope?.matchMedia}
            context={STRIPE_FORM_CONTEXT.prepay}
            prepayAccountId={accountId}
            prepayClientKey={clientSecret}
            stripePublishableKey={stripePublishableKey}
          />
        </div>
      </div>
    </div>
  );
}

PrepayStripe.propTypes = {
  $rootScope: PropTypes.shape({
    matchMedia: PropTypes.shape(PropTypes.object.isRequired),
  }).isRequired,
  AutomationMode: PropTypes.bool.isRequired,
  clientSecret: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  stripePublishableKey: PropTypes.string.isRequired,
};

PrepayStripe.displayName = 'PrepayStripe';
